import { RouteObject } from 'react-router-dom';

import { ForgotPassword } from './ForgotPassword';
import { ResetPassword } from './ResetPassword';

export const forgotPassword: RouteObject[] = [
  { path: 'forgot-password', element: <ForgotPassword /> },
  { path: 'reset-password', element: <ResetPassword /> }
];
